
// Wanneer je in een text element (of iets anders) op de enter knop klikt, een bepaalde knop te activeren.
// e.g. <input type='text' onkeydown='return onEnterActivateButton(event,\"categories\")' />
function onEnterActivateButton(event, button) {
	
	// 13 is enter knop.
	if ( event.keyCode != 13 ) return;
	
	document.getElementById(button).click();
	
	// Dit is belangrijk omdat anders het formulier alsnog gesubmit wordt
        event.preventDefault();
	return false;
}

function XMLHttpObject() {
	
	// Voor normale browsers en IE7+.
	if ( window.XMLHttpRequest ) {
		return new XMLHttpRequest();
	}
	
	// Voor IE5 en IE6.
	if ( window.ActiveXObject ) {
		return new ActiveXObject("Microsoft.XMLHTTP");
	}
	
	return null;
}

function performSearch(id, mode, searchElementId, containerId) {
	
	var xmlhttp = XMLHttpObject();
	
	// Waar het resultaat in komt te staan.
	var container = document.getElementById(containerId);
	
	// De functie die de ajax request afhandeld.
	xmlhttp.onreadystatechange = function() {
		
		if ( xmlhttp.readyState == 4 ) {
			container.innerHTML = xmlhttp.responseText;
		} else {
			container.innerHTML = "loading results...";
		}
	};
	
	var searchVal = document.getElementById(searchElementId).value;
	
	// Pagina die we opvragen om suggesties terug te geven.
	searchUrl = "/admin/stream/search";
	
	xmlhttp.open('GET', searchUrl + '?searchall=' + escape(searchVal) + '&q=' + escape(mode) + '&i=' + escape(id),true);
	
	xmlhttp.send(null);
}
